import {ITemplateModel} from "@/components/template/models";
import {EAnalysisTasks, EModules} from "@/models";
import {EDeviceClasses} from "@toolbox/models";

export enum EAnalysisTab {
    Task,
    Standard,
    Template,
}

export interface IModuleGroup {
    modules: EModules[];
    id: string;
    header?: React.ReactChild;
}

export interface IModuleItemGroup extends IModuleGroup {
    items: ITemplateModel[];
}

export interface IModulesResponse {
    modules: EModules[];
    tasks: EAnalysisTasks[];
    devices: EDeviceClasses[];
}

export interface IModuleGroupDevices {
    modules: IModuleTaskGroup[];
    devices: EDeviceClasses[];
}

export interface IModuleTaskGroup {
    modules: IModuleTaskGroupEntry[];
    id: string;
    header?: React.ReactChild;
}

export interface IModuleTaskGroupEntry {
    item: IModuleByTask | IModuleTaskGroup;
}

export interface IModuleByTask {
    module: EModules;
    task: EAnalysisTasks;
}
